<template>
    <div class="famous-comment-all-list">
        <div class="famous-comment-all-list-top-bar">
            <!-- 1. 标题栏 -->
            <div class="famous-comment-all-list-title dsp-flex">
                <div class="famous-cal-side-l">
                    <div class="famous-cla-side-close">
                        <span class="famous-cal-close" @click="clickClose">
                            <i class="iconfont icon-xiangzuo"></i>
                        </span>
                        <span v-if="CONFIG.platform != 'web'" class="famous-cal-event" @click="toggleEvent">
                            <i class="iconfont" v-bind:class="{'icon-shi1': showPediaCommentEvent, 'icon-shi2': !showPediaCommentEvent}"></i>
                        </span>
                    </div>
                </div>
                <!-- 动态设置标题 -->
                <div class="famous-cal-middle">{{commentAllTitle}}分析({{commentAllSelectedList.length + commentAllMainList.length}}条)</div>
                <div class="famous-cal-side-r">
                    <div class="famous-cal-side-more">
                        <span v-if="CONFIG.platform != 'web'" class="famous-cal-show" @click="toggleFateFortune">
                            <i class="iconfont" v-bind:class="{'icon-yun1': showPediaCommentFateFortune, 'icon-yun2': !showPediaCommentFateFortune}"></i>
                        </span>
                        <span class="famous-cal-order" @click="toggleOrder">
                            <i class="iconfont" v-bind:class="'icon-order-' + commentAllSort"></i>
                        </span>
                    </div>
                </div>
            </div>
            <!-- 2. 事件内容描述 -->
            <div v-if="commentAllContent != '' && showPediaCommentEvent" class="famous-comment-content-box scroll-touch">
                <div class="famous-comment-content-part">
                    <p v-html="UTILS.getBreakLineByText(commentAllContent)"></p>
                </div>
            </div>
        </div>
        <div class="famous-comment-list-box">
            <!-- 3. 精选评论 -->
            <div v-if="commentAllSelectedList.length > 0" class="famous-comment-choice-list">
                <div class="famous-cal-sub-title">精选评论({{commentAllSelectedList.length}})</div>
                <div class="famous-cal-list-content" v-if="CONFIG.platform == 'web'">
                    <famous-comment-item-all-web
                        v-for="itemData in commentAllSelectedList"
                        v-bind:key="itemData.key+itemData.id"
                        v-bind:itemData="itemData"
                        v-bind:secondList="commentTotalReplySecondData"
                        v-bind:operateFunc="clickCommentOperate">
                    </famous-comment-item-all-web>
                </div>
                <div v-else>
                    <famous-comment-item-all
                        v-for="itemData in commentAllSelectedList"
                        v-bind:key="'choice'+itemData.id"
                        v-bind:type="'selected'"
                        v-bind:itemData="itemData"
                        v-bind:secondList="commentTotalReplySecondData"
                        v-bind:className="'famous-cal-choice-item'"
                        v-bind:operateFunc="clickCommentItemOperate">
                    </famous-comment-item-all>
                </div>
            </div>
            <!-- 4. 评论 -->
            <div v-if="commentAllMainList.length > 0" class="famous-comment-main-list">
                <div class="famous-cal-sub-title">评论({{commentAllMainList.length}})</div>
                <div class="famous-cal-list-content" v-if="CONFIG.platform == 'web'">
                    <famous-comment-item-all-web
                        v-for="itemData in commentAllMainList"
                        v-bind:key="itemData.key+itemData.id"
                        v-bind:itemData="itemData"
                        v-bind:secondList="commentTotalReplySecondData"
                        v-bind:operateFunc="clickCommentOperate">
                    </famous-comment-item-all-web>
                </div>
                <div v-else>
                    <famous-comment-item-all
                        v-for="itemData in commentAllMainList"
                        v-bind:key="'main'+itemData.id"
                        v-bind:type="'main'"
                        v-bind:itemData="itemData"
                        v-bind:secondList="commentTotalReplySecondData"
                        v-bind:className="'famous-cal-choice-item'"
                        v-bind:operateFunc="clickCommentItemOperate">
                    </famous-comment-item-all>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS, UA } from '../../modules/utils'
import FamousCommentItemAll from '../../components/famouspedia/FamousCommentItemAll.vue'
import FamousCommentItemAllWeb from '../../components/famouspedia/FamousCommentItemAllWeb.vue'
import { FAMOUS_DOM } from '../../modules/dom';
import { CONFIG } from '../../modules/config'
export default {
    name: 'FamousCommentAllList',
    components: { FamousCommentItemAll, FamousCommentItemAllWeb },
    computed: {
        commentAllTitle() {
            return this.$store.state.famouspediacomment.commentAllTitle;
        },
        commentAllContent() {
            return this.$store.state.famouspediacomment.commentAllContent;
        },
        commentAllSort() {
            return this.$store.state.famouspediacomment.commentAllSort;
        },
        commentTotalReplySecondData() {
            return this.$store.state.famouspediacomment.commentTotalReplySecondData;
        },
        commentAllSelectedList() {
            return this.$store.getters.commentAllSelectedList;
        },
        commentAllMainList() {
            return this.$store.getters.commentAllMainList;
        },
        showPediaCommentEvent() {
            return this.$store.state.famouspediacomment.showPediaCommentEvent;
        },
        showPediaCommentFateFortune() {
            return this.$store.state.famouspediacomment.showPediaCommentFateFortune;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            CONFIG: CONFIG
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topBarDiv = document.getElementsByClassName('famous-pedia-fate-topbar')[0];
            if(topBarDiv) {
                this.$el.style.paddingTop = topBarDiv.clientHeight + 'px';
            }
        },
        clickClose() {
            var baikeId = this.$store.state.famouspedia.curPediaBaziId,
                itemId = this.$store.state.famouspediacomment.commentAllYear;
            this.$store.dispatch('famouspediacomment/resetAllData');
            // 重置表单数据
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: baikeId,
                    f_type: 'all',
                    parentsid: 0,
                    touid: 0
                }
            });
            // 将页面恢复到这个定位
            this.$bus.emit('triggerTitleLinkItem', itemId);
        },
        clickCommentItemOperate(opType, commentData) {
            // opType:more like reply checkreply
            console.log('clickCommentItemOperate-----', opType, commentData)
            var baikeId = this.$store.state.famouspedia.curPediaBaziId,
                userData = this.$store.state.userData;
            userData = userData && userData.info ? userData.info : {};
            switch(opType) {
                case 'more':
                    this.$bus.emit('updateCommentReport');
                    this.$store.dispatch('famouspediacomment/initCommentAllListMore', {
                        data: commentData,
                        userData: userData
                    })
                    break;
                case 'like':
                    this.$store.dispatch('famouspediacomment/toggleLikeComment', {
                        baikeId: baikeId,
                        data: commentData
                    });
                    break;
                case 'reply':
                    this.$store.state.famouspediacomment.commentTextAreaToName = commentData.userName;
                    this.$store.dispatch('famouspediacomment/setCommentFormData', {
                        formData: {
                            bid: baikeId,
                            f_type: commentData.key,
                            parentsid: commentData.parentsid == 0 ? commentData.id : commentData.parentsid,
                            touid: commentData.uid
                        },
                        cb: function() {
                            setTimeout(() => {
                                if(!UA.isIphone()) {
                                    FAMOUS_DOM.focusBottomBarTextArea();
                                }
                            }, 20);
                        }
                    });
                    break;
                case '':
                    break;
                default:
                    break;
            }
        },
        clickCommentOperate(opType, commentData) {
            var me = this,
                baikeId = this.$store.state.famouspedia.curPediaBaziId;
            console.log('clickCommentOperate-----', opType, commentData)
            switch(opType) {
                case 'like':
                    this.$store.dispatch('famouspediacomment/toggleLikeComment', {
                        from: 'list',
                        baikeId: baikeId,
                        data: commentData
                    });
                    break;
                case 'reply':
                    this.$store.dispatch('famouspediacomment/setCommentFormData', {
                        formData: {
                            bid: baikeId,
                            f_type: commentData.key,
                            parentsid: commentData.parentsid == 0 ? commentData.id : commentData.parentsid,
                            touid: commentData.uid
                        },
                        cb: function() {
                            setTimeout(() => {
                                if(!UA.isIphone()) {
                                    FAMOUS_DOM.focusBottomBarTextArea();
                                }
                            }, 20);
                        }
                    });

                    this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                        key: commentData.key,
                        cb: function() {
                            setTimeout(() => {
                                FAMOUS_DOM.updateFamousFormStyle();
                                FAMOUS_DOM.bindFamousFormScrollEvent(false);
                                me.$bus.emit('focusFamousBottomBar');
                                if(CONFIG.platform != 'web') {
                                    window.scrollTo(0, 0);
                                }
                                me.$store.state.famouspediacomment.commentTextAreaToName = commentData.userName;

                                // 设置迷你命盘数据
                                var itemId = me.$store.state.famouspediacomment.commentAllYear;
                                me.$bus.emit('triggerTitleLinkItem', itemId)
                            }, 20);
                        }
                    });
                    break;
                default:
                    break;
            }
        },
        toggleEvent() {
            var showPediaCommentEvent = this.$store.state.famouspediacomment.showPediaCommentEvent;
            this.$store.state.famouspediacomment.showPediaCommentEvent = !showPediaCommentEvent;
            setTimeout(() => {
                FAMOUS_DOM.updateFamousFormStyle();
            }, 20);
        },
        toggleFateFortune() {
            var showPediaCommentFateFortune = this.$store.state.famouspediacomment.showPediaCommentFateFortune;
            this.$store.state.famouspediacomment.showPediaCommentFateFortune = !showPediaCommentFateFortune;
            setTimeout(() => {
                FAMOUS_DOM.updateFamousFormStyle();
            }, 20);
        },
        toggleOrder() {
            this.$store.state.famouspediacomment.commentAllSort = this.commentAllSort == 1 ? 2 : 1;
        }
    }
}
</script>